// SidebarBuckets.jsx

import React from 'react';

// Hooks
import useSidebarBucketsState from './hooks/useSidebarBucketsState';

// CSS
import './SidebarBuckets.css';

// Components
import SidebarBucket from './SidebarBucket';
import SidebarBucketsModals from './SidebarBucketsModals';

/**
 * SidebarBuckets
 *
 * Renders module and workspace sidebar buckets and persists the open bucket by user/workspace.
 *
 * @param {function} onDatabaseClick - Called when a database row is selected.
 * @param {function} onRequestClose - Called when a mobile sidebar action should close the drawer.
 *
 * @returns {ReactNode} The rendered sidebar buckets section.
 */
const SidebarBuckets = React.memo(({ onDatabaseClick, onRequestClose }) => {
    const {
        bucketListState,
        modalState,
        handlers,
    } = useSidebarBucketsState({ onRequestClose });

    // ----- RENDER ----- //

    return (
        <div className="sidebar-buckets-container">
            {bucketListState.buckets.map((bucket) => {
                const isOpen = bucketListState.openBucketKey === bucket.key;
                const showHeader = bucket.key !== 'workspace';

                return (
                    <SidebarBucket
                        key={bucket.key}
                        bucket={bucket}
                        isOpen={isOpen}
                        showHeader={showHeader}
                        onToggle={handlers.handleBucketToggle}
                        onDashboardClick={handlers.handleDashboardClick}
                        onChannelClick={handlers.handleChannelClick}
                        onDatabaseClick={onDatabaseClick}
                        onAddFromTemplate={handlers.handleAddFromTemplate}
                        onAddChannel={handlers.handleAddChannel}
                        onAddDatabase={handlers.handleAddDatabase}
                    />
                );
            })}

            <SidebarBucketsModals modalState={modalState} />
        </div>
    );
});

// Dev Tools
SidebarBuckets.displayName = 'SidebarBuckets';

export default SidebarBuckets;